import React  from 'react';
import { Modal, Button } from 'tea-component';

import './index.scss';

// 编辑确认弹窗
export default function EditConfirmPopup(props: any) {
  const { visible, close } = props;
  return (
    <Modal
      className="feeds-confirmpopup"
      visible={visible}
      onClose={() => {
        close();
      }}
    >
      <Modal.Body>
        {/* 此处icon类型必须写 success，样式对对应icon做了替换*/}
        <Modal.Message
          icon="success"
          message="Operation Success!"
          description="The correct translation will be displayed after daily update, thank
            you for your feedback and help!"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            close && close();
          }}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
